import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetEnrollmentRequiredDocumentsQuery } from "../../hooks/useGetEnrollmentRequiredDocumentsQuery";
import { setUpdateEnrollmentRequiredDocumentData } from "../../redux/slices/school/enrollmentRequiredDocument";
import { routes } from "../../routes";
import { updateEnrollmentRequiredDocument } from "../../services/school/enrollmentRequiredDocument/updateEnrollmentRequiredDocument";
import { EnrollmentRequiredDocumentType } from "../../types/EnrollmentRequiredDocument";
import { Key_enrollmentRequiredDocuments } from "../../utils/constants";


const columnNamesMap: { [key: string]: string } = {
    description: 'Documento',
};
export const EnrollmentRequiredDocuments = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetEnrollmentRequiredDocumentsQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationUpdateEnrollmentRequiredDocument = useMutation(updateEnrollmentRequiredDocument, {
        onSuccess: () => {
            queryClient.invalidateQueries(Key_enrollmentRequiredDocuments);
            toast.success('Tipo de documento apagado');
        },
        onError: () => {
            toast.error("Erro ao apagar tipo de documento.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createEnrollmentRequiredDocument)
    }
    const handleEdit = (enrollmentRequiredDocument: EnrollmentRequiredDocumentType) => {
        dispatch(setUpdateEnrollmentRequiredDocumentData(enrollmentRequiredDocument));
        navigate(routes.updateEnrollmentRequiredDocument)
    };
    const handleDelete = (enrollmentRequiredDocument: EnrollmentRequiredDocumentType) => {
        enrollmentRequiredDocument.status = false;
        mutationUpdateEnrollmentRequiredDocument.mutateAsync(enrollmentRequiredDocument)
    };

    const options = data?.items.map((enrollmentRequiredDocument: EnrollmentRequiredDocumentType) => [
        {
            label: 'Editar',
            onClick: (enrollmentRequiredDocument: EnrollmentRequiredDocumentType) => handleEdit(enrollmentRequiredDocument),
            icon: <Pencil1Icon />
        },
        {
            label: 'Excluir',
            onClick: (enrollmentRequiredDocument: EnrollmentRequiredDocumentType) => handleDelete(enrollmentRequiredDocument),
            icon: <TrashIcon />
        }
    ]) || [];

    return (
        <Lists status={status}
            TableComponent={
                () =>
                    <TableComponent
                        columns={['description']}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange} />
            }
            handleClickCreate={handleClickCreate} />
    );
}